export enum FileRecordColumn {
    DeliveryFileName,
    FilePath,
    Content,
    RecordType,
    Info,
    Reference,
    Details,
    BuzzNotifications,
    Status,
    UpdateDate,
    Notes,
    Actions,
    CreateDate,
    StatusDetails,
    Link
}

export interface FileRecordListingConfig {
    pageSize: number;
    columns: ConfiguredFileRecordColumns;
}

type ConfiguredFileRecordColumns = Record<FileRecordColumn, ColumnConfig>;

export interface ColumnConfig {
    order: number;
    visible: boolean;
}

export const getDefaultFileRecordListingConfig = (): FileRecordListingConfig => ({
    pageSize: 50,
    columns: {
        [FileRecordColumn.DeliveryFileName]: { order: 1, visible: true },
        [FileRecordColumn.Link]: { order: 2, visible: true },
        [FileRecordColumn.FilePath]: { order: 3, visible: true },
        [FileRecordColumn.Content]: { order: 4, visible: true },
        [FileRecordColumn.RecordType]: { order: 5, visible: true },
        [FileRecordColumn.Info]: { order: 6, visible: true },
        [FileRecordColumn.Reference]: { order: 7, visible: true },
        [FileRecordColumn.Details]: { order: 8, visible: true },
        [FileRecordColumn.BuzzNotifications]: { order: 9, visible: true },
        [FileRecordColumn.Status]: { order: 10, visible: true },
        [FileRecordColumn.StatusDetails]: { order: 11, visible: true },
        [FileRecordColumn.CreateDate]: { order: 12, visible: true },
        [FileRecordColumn.UpdateDate]: { order: 13, visible: true },
        [FileRecordColumn.Notes]: { order: 14, visible: true },
        [FileRecordColumn.Actions]: { order: 15, visible: true }
    }
});

export const sortColumnsByConfiguredOrder = (columnConfig: ConfiguredFileRecordColumns): [string, ColumnConfig][] => {
    /* ensures that columns not present in LocalStorage config (i.e. newly added) are present in the listing config modal */
    const allColumns: ConfiguredFileRecordColumns = { ...getInvisibleDefaultColumns(), ...columnConfig };

    return Object.entries(allColumns).sort(([, column_1], [, column_2]) => column_1.order - column_2.order);
};

const getInvisibleDefaultColumns = () => {
    const defaultColumns = getDefaultFileRecordListingConfig().columns;
    const entries = Object.entries(defaultColumns).map(([colName, colCfg]) => [colName, { ...colCfg, visible: false }]);

    return Object.fromEntries(entries);
};
